import React from 'react';

import { EmptyPage } from 'apps/auth/components/common/Layout/EmptyPage/EmptyPage';

const EmptyCards = (props) => {
    return <EmptyPage iconName="bank" emptyText={props.title} />;
};

export default EmptyCards;
